import { roles } from "../config/config";

export const getSalesPermissions = (userIsAgente, user) => [
  roles.admin,
  roles.gestore,
  roles.developer,
  roles.magazziniere,
  userIsAgente && parseInt(user.acquisti, 10) > 0,
];

export const salesItemPermissions = [
  roles.admin,
  roles.gestore,
  roles.developer,
  roles.magazziniere,
  roles.contabile,
];

export const getSalesItemPermissions = (userIsAgente) => [
  ...salesItemPermissions,
  userIsAgente,
];

export const getSalesClientPermissions = (userIsAgente) => [userIsAgente];

export const salesSummaryPermissions = [
  roles.admin,
  roles.gestore,
  roles.developer,
  roles.magazziniere,
  roles.contabile,
];

export const getSalesSummaryPermissions = (userIsAgente) => [
  ...salesSummaryPermissions,
  userIsAgente,
];
